export const ROUTES = {
  home: '/',
  programs: '/programs',
  successStories: '/success-stories',
  space: '/space',
  framework: '/framework',
  mediaRelations: '/mediarelation',
  pressConference: '/mediarelation/press conference',
  news: '/news',
  contact: '/contact'
};
